

























import Vue from 'vue';
import Component from 'vue-class-component';
import { ClientService } from '../../service/ClientService';
import { DxTagBox, DxButton, DxScrollView } from 'devextreme-vue';
import CustomStore from 'devextreme/data/custom_store';
import { UserService } from '../../service/UserService';
import { AlertMessage } from '@questelservices/common-vue';

@Component({
  components: {
    DxTagBox,
    DxButton,
    DxScrollView,
    AlertMessage
  }
})
export default class UserAssignedClients extends Vue {
  private clients: Array<{ text: string; value: Guid }> = [];
  private userClient: Array<Guid> = [];
  private userService: UserService = new UserService();
  private dataMessageType: string = '';
  private dataMessage: string = '';

  constructor() { 
    super();
    this.loadData();
  }

  async loadData(): Promise<void> {    
    let clientService = new ClientService();
    let clients = await clientService.getAll();
    this.clients = clients.map(c => {
      return { text: c.ClientName, value: c.ClientId };
    });

    this.userClient = await this.userService.getAssignedClients();
  }

  async onCancelClick(): Promise<void> {
    this.userClient = await this.userService.getAssignedClients();
  }

  onSaveClick(): Promise<any> {
    return this.userService.updateAssignedClient(this.userClient)
      .then(success => {
        this.dataMessageType = 'success';
        this.dataMessage = 'Changes successfully saved.';
        this.resetMessage();
        return true;
      })
      .catch(error => {
        this.dataMessageType = 'error';
        this.dataMessage = 'An unexpected error occurred. Please try again.';
        return false;
      });
  }

  resetMessage(): void {
    setTimeout(() => {
      this.dataMessageType = '';
      this.dataMessage = '';
    }, 5000);
  }
}
